module.exports = __webpack_public_path__ + "static/img/ancunu06.2307ffe6.png";